import React from 'react';
import { useInView } from '../../lib/useInView';

const LandingScrollReveal = ({ children, className = '', delay = 0, as: Tag = 'div' }) => {
  const [ref, inView] = useInView();

  return (
    <Tag
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default LandingScrollReveal;
